module.exports = __webpack_public_path__ + "img/3.d40d2305.png";